var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFutsal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 96 96",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48 2a47.6 47.6 0 0 1 19.64 4.24C66.32 7.08 60.76 10 48 10S29.68 7.08 28.36 6.24A47.6 47.6 0 0 1 48 2m0 12c13.08 0 23.64 8.96 23.64 20S61.08 54 48 54s-23.64-8.96-23.64-20S34.92 14 48 14M18.16 34a36 36 0 0 0 4.48-24.72A48 48 0 0 0 0 50a44.4 44.4 0 0 0 .52 6.56A77.6 77.6 0 0 0 18.16 34m59.602 0a36.28 36.28 0 0 1-4.48-24.76A48 48 0 0 1 96.002 50a46 46 0 0 1-.52 6.8A77.7 77.7 0 0 1 77.762 34m-71.4 21.6a17.36 17.36 0 0 0-4.44 7.8A48 48 0 0 0 29.082 94a18.16 18.16 0 0 0 10.92-4.92c8-8 6.72-21.68-2.52-30.92s-23.28-10.4-31.12-2.56m49.8 33.32c-7.84-7.84-6.68-21.68 2.56-30.92 9.28-9.08 23.08-10.24 30.92-2.68a17.4 17.4 0 0 1 4.4 8A48 48 0 0 1 66.882 94a17.92 17.92 0 0 1-10.72-5.08"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFutsal);
export default __webpack_public_path__ + "static/media/futsal.299b3237f9ca5affc7097181b7286f50.svg";
export { ForwardRef as ReactComponent };